export const EXPORT_TO_JSON = { displayName: 'JSON', value: 'json' };
export const EXPORT_TO_IMAGE = { displayName: 'Image/PNG', value: 'image' };

export const DASHBOARD_EXPORT_TO_IMAGE_IGNORED_CLASSES = [
    'modal-backdrop',
    'dashboard-portlet-icons',
    'dashboard-contextual-menu',
    'new-chart-placeholder',
    'dashboard-overrides-buttons',
];

export const DASHBOARD_EXPORT_TO_IMAGE_IGNORED_ELEMENTS = ['options-button'];
